import anyConst from './anySpecialHome'
import takeConst from './takeSpecialHome'

export function getSpecialHomeConst (project: 'any' | 'take' = 'any') {
  if (project === 'take') {
    return takeConst
  }

  return anyConst
}
